import { render, staticRenderFns } from "./testAccount.vue?vue&type=template&id=742ba32a&scoped=true"
import script from "./testAccount.vue?vue&type=script&lang=js"
export * from "./testAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742ba32a",
  null
  
)

export default component.exports